import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import CacheTag from './cacheTags';

const baseUrl = import.meta.env.VITEST ? 'http://localhost' : '';

export const api = createApi({
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers) => {
      headers.set('X-CSRF', '1');
      return headers;
    },
    baseUrl,
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item !== undefined && item !== null) {
              searchParams.append(key, String(item));
            }
          });
          return;
        }

        searchParams.append(key, String(value));
      });

      return searchParams.toString();
    },
  }),
  // We don't define any endpoints here. They are injected from separate files.
  endpoints: () => ({}),
  tagTypes: Object.values(CacheTag),
});
